import React, {useState} from "react";
import {composeValidators, required, limit} from "../../helpers/ValidateHelper";
import {useSelector} from "react-redux";
import {Field, useForm} from "react-final-form";
import SelectField from "../fields/SelectField";
import Error from "../fields/Error";
import OtherField from "../fields/OtherField";
import {filterOption} from "../../helpers/OptionHelper";
import WindowWidthProvider from "../../helpers/WindowWidthProvider";
import useSyncedField from "../../hooks/useSyncedField";

function Discipline() {
    const options = useSelector(state => state.orderOptions.data.subject);
    const otherOption = options[options.length - 1];
    const [allOptions, setOptions] = useState(options);
    const windowWidth = WindowWidthProvider();

    useSyncedField("subject", "string");
    useSyncedField("subjectOther", "string");

    const {change} = useForm();

    const filterAllOptions = rawInput => {
        const filteredOptions = filterOption(options, rawInput);
        if (filteredOptions.length === 0) {
            filteredOptions.push(otherOption);
        }
        setOptions(filteredOptions);
    };

    return (
        <div className="form-group dd-form-group">
            <div className="form-label">
                Discipline <span className="rq">*</span>
            </div>
            <Field
                name="subject"
                component={SelectField}
                isSearchable={true}
                currentWidth={windowWidth}
                options={allOptions}
                disableDefaultFilter={true}
                onInputChange={filterAllOptions}
                validate={required('Please specify type subject')}
                onChange={value => {
                    if (value && !allOptions.some(subject => String(subject.value) === String(value))) {
                        change('subject', 'Other');
                        change('subjectOther', value);
                    } else {
                        change('subject', value);
                    }
                }}
            />
            <Error name="subject"/>
            <OtherField
                name="subjectOther"
                watch="subject"
                validate={composeValidators(
                    required('Please specify type subject'),
                    limit('Maximum {limit} characters allowed. You\'ve used {count}.', 255)
                )}
            />
        </div>
    );
}

export default Discipline;
